import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

// ---------- Swiper ----------
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import { useTranslation } from "react-i18next";
const API_BASE_URL = "https://api.mahal.qa/api";
const RESTAURANT_ID = 1;

const RelatedProducts = ({ productId, onProductClick }) => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const [loading, setLoading] = useState(true);
  /* ================= FETCH RELATED PRODUCTS ================= */
  useEffect(() => {
    if (!productId) return;

    setLoading(true);

    axios
      .get(
        `${API_BASE_URL}/related?product_id=${productId}&lang=${i18n.language}`
      )
      .then((res) => {
        setProducts(res.data.products || []);
      })
      .catch((err) => {
        console.error("RELATED PRODUCTS ERROR", err);
        setProducts([]);
      })
      .finally(() => {
        setLoading(false);
      });

  }, [productId, i18n.language]);

  /* ================= ADD TO CART ================= */
  const addToCart = (e, item) => {
    e.stopPropagation();

    const token = localStorage.getItem("token");
    if (!token) {
      alert("Please login");
      return;
    }

    axios
      .post(
        `${API_BASE_URL}/cart/add`,
        {
          product_id: item.id,
          quantity: 1,
          price: item.price_numeric,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then(() => {
        const go = window.confirm("Added to cart 🛒\n\nGo to cart?");
        if (go) {
          navigate("/cartview");
        }
      })
      .catch((err) => {
        console.error("ADD TO CART ERROR", err);
        alert("Add to cart failed");
      });
  };

  /* ================= ADD TO WISHLIST ================= */

  const addToWishlist = (e, item) => {
    e.stopPropagation();

    const token = localStorage.getItem("token");
    if (!token) {
      alert("Please login");
      return;
    }

    axios
      .post(
        `${API_BASE_URL}/wishlist/add`,
        {
          product_id: item.id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then(() => {
        const go = window.confirm("Added to wishlist ❤️\n\nGo to wishlist?");
        if (go) {
          navigate("/wishlist");
        }
      })
      .catch((err) => {
        if (err.response?.status === 409) {
          alert("Already in wishlist ❤️");
        } else {
          console.error("WISHLIST ERROR", err);
          alert("Wishlist failed");
        }
      });
  };

  /* ================= QUICK VIEW (EYE ICON) ================= */
  const quickView = (e, item) => {
    e.stopPropagation();

    console.log("CLICKED PRODUCT:", item.id);

    if (onProductClick) {
      onProductClick(item.id);
    }

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <section className="related_product pt_95 xs_pt_75 pb-80">
      <div className="container">

        {loading ? (
  <div
    style={{
      textAlign: "center",
      padding: "40px",
      fontSize: "18px",
    }}
  >
    {isArabic
      ? "جاري تحميل المنتجات ذات الصلة..."
      : "Loading Related Products..."}
  </div>
) : (

        <Swiper
          dir={isArabic ? "rtl" : "ltr"}
          modules={[Navigation, Autoplay]}
          navigation
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            reverseDirection: isArabic,
          }}
          loop={true}
          spaceBetween={30}
          slidesPerView={4}
          breakpoints={{
            0: { slidesPerView: 1 },
            576: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
            1200: { slidesPerView: 4 },
          }}
        >
          {products.map((item) => (
            <SwiperSlide key={item.id}>
              <div
                className="single_product"
                style={{ cursor: "pointer" }}
                onClick={() => navigate(`/shopdetails/${item.id}`)}
              >
                {/* IMAGE */}
                <div className="single_product_img">
                  <img
                    src={item.img1}
                    alt={item.name}
                    className="img-fluid w-100"
                  />

                  <ul>
                    <li>
                      <button
                        type="button"
                        className="icon_btn"
                        onClick={(e) => quickView(e, item)}
                      >
                        <i className="far fa-eye"></i>
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        className="icon_btn"
                        onClick={(e) => addToWishlist(e, item)}
                      >
                        <i className="far fa-heart"></i>
                      </button>
                    </li>
                  </ul>
                </div>

                {/* TEXT */}
                <div className="single_product_text">
                  <h5 className="title">
                    {isArabic ? item.name_ar || item.name : item.name}
                  </h5>
                  <p>{item.price}</p>

                  <button
                    className="cart_btn"
                    disabled={item.stock === 0}
                    onClick={(e) => addToCart(e, item)}
                  >
                    <i className="far fa-shopping-basket"></i>
                    {item.stock === 0 ? t("outOfStock") : t("addToCart")}
                  </button>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        )}
      </div>
    </section>
  );
};

export default RelatedProducts;